var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":'审核',"okText":"确定","width":450,"wrapClassName":"recommend-modal"},on:{"ok":_vm.save},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('p',{style:({ marginTop: '20px' })},[_vm._v("确定客户信息无误，可上线？")])])
}
var staticRenderFns = []

export { render, staticRenderFns }